export default __webpack_public_path__ + "victory-57282590fa7232b98346b0e23e204f2e.png";